import type { actions, paths } from '@luxuryescapes/contract-svc-merchandise';

import { json_headers, request } from './common';

const BASE_PATH = `${window.configs.API_HOST}/api/merchandise`;

export type MerchandiseOrderGetResponse =
  paths['/api/merchandise/orders/{id}']['get']['responses']['200']['content']['application/json'];

export type MerchandiseItemType = MerchandiseOrderGetResponse['result']['items'][number];

export function getMerchandiseOrder(orderId: string): Promise<MerchandiseOrderGetResponse> {
  const uri = `${BASE_PATH}/orders/${orderId}`;

  return request(uri, { method: 'GET' });
}

export type MerchandiseAdvertGetResponse = actions['getAdvert']['responses']['200']['content']['application/json'];
export type MerchandiseAdvertType = MerchandiseAdvertGetResponse['result']['advert'];

export function getMerchandiseAdvert(advertId: string): Promise<MerchandiseAdvertType> {
  const uri = `${BASE_PATH}/adverts/${advertId}`;

  return request(uri, { method: 'GET' }).then((response) => response.result.advert);
}

export type ColorsGetResponse =
  paths['/api/merchandise/colors']['get']['responses']['200']['content']['application/json'];

export type Color = ColorsGetResponse['result']['colors'][number];

export type CreateColorRequest = paths['/api/merchandise/colors']['post']['requestBody']['content']['application/json'];

export type CreateColorResponse =
  paths['/api/merchandise/colors']['post']['responses']['201']['content']['application/json'];

export type UpdateColorRequest =
  paths['/api/merchandise/colors/{name}']['put']['requestBody']['content']['application/json'];

export type UpdateColorResponse =
  paths['/api/merchandise/colors/{name}']['put']['responses']['200']['content']['application/json'];

export function getColors(options?: { signal?: AbortSignal }): Promise<ColorsGetResponse> {
  const uri = `${BASE_PATH}/colors`;

  return request(uri, { method: 'GET', signal: options?.signal });
}

export function updateColor(colorName: string, colorData: UpdateColorRequest): Promise<UpdateColorResponse> {
  return request(`${BASE_PATH}/colors/${colorName}`, {
    method: 'PUT',
    headers: json_headers,
    body: JSON.stringify(colorData),
  });
}

export function createColor(colorData: CreateColorRequest): Promise<CreateColorResponse> {
  return request(`${BASE_PATH}/colors`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(colorData),
  });
}

export function deleteColor(colorName: string): Promise<void> {
  return request(`${BASE_PATH}/colors/${colorName}`, {
    method: 'DELETE',
  });
}
